<template>
	<div
		v-touch:tap="tapHandler"
		v-touch:swipe.left="swipeLeftHandler"
		v-touch:swipe.right="swipeRightHandler"
		@contextmenu.prevent="contextMenuHandler"
		style="user-select: none; cursor: pointer"
		@keyup.enter="tapHandler"
		tabindex="0"
		role="link"
	>
		<template v-if="data">
			<div class="row">
				<div
					v-for="col in cols"
					:class="`col-xs-12 col-${breakpoint}-${col.size}`"
					v-bind:key="col.key"
				>
					<span :class="`font-bold mr-2 d-${breakpoint}-none`">{{
						col.heading
					}}</span>
					{{ data[col.key] }}
				</div>
			</div>
			<button
				class="btn btn-danger float-right"
				v-if="showDeleteBtn"
				v-touch:tap.stop="deleteItem"
			>
				{{$t('delete')}}
			</button>
		</template>

		<template v-else>
			<div>
				<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
				<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
				<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
				<div class="skeleton midnight h20 w50 mr-4 float-left"></div>
			</div>
		</template>
	</div>
</template>

<script>
export default {
	props: {
		cols: Array,
		data: Object,
		swipedLeftItem: Object,
		breakpoint: String,
		idProperty: String,
		deletePriv: String
	},
	components: {
	},
	data() {
		return {
			user: null,
			mouseDownClientX: null,
			mouseDownClientY: null,
		};
	},
	mounted() {
		if (this.data) {
			this.getUserDetails();
		}
	},
	created: function () {},
	destroyed: function () {},
	methods: {
		deleteItem() {
			this.$emit("deleteItem", this.data);
		},
		tapHandler(e) {
			// ignore for right clicks
			if (e.button && e.button == 2) {
				return false;
			}

			if (this.data) {
				this.$emit("selectItem", this.data);
			}
		},
		mouseDownHandler(e) {
			this.mouseDownClientX = e.clientX;
			this.mouseDownClientY = e.clientY;
		},
		swipeLeftHandler() {
			this.$emit("swipeLeftItem", this.data);
		},
		swipeRightHandler() {
			this.$emit("swipeRightItem", this.data);
		},
		contextMenuHandler() {
			this.$emit("contextMenuItem", this.data);
		},
		getUserDetails() {
			this.$users.getUserById.call(this, this.data.student).then((user) => {
				this.user = user;
			});
		},
	},
	computed: {
		showDeleteBtn() {
			return (
				this.swipedLeftItem &&
				this.idProperty &&
				this.swipedLeftItem[this.idProperty] == this.data[this.idProperty] &&
				(
					!this.deletePriv ||
					this.$UserSession.hasPriv.call(this, this.deletePriv)
				)
			);
		}
	},
};
</script>
